import { browserHistory } from 'react-router';
import { omit } from 'lodash';

/**
 * @param {Object} query
 */
export const addQuery = (query) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation());

  Object.assign(location.query, query);
  // Removing event and docusignEnvelopeId from querystring when posting question
  // to allow more than one docusign question per form
  location.query = { ...omit(location.query, ['docusignEnvelopeId', 'event']) };
  // or simple replace location.query if you want to completely change params

  browserHistory.push(location);
};

/**
 * @param {...String} queryNames
 */
export const removeQuery = (...queryNames) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation());
  queryNames.forEach((q) => delete location.query[q]);
  browserHistory.push(location);
};
